import {AuthService} from "./AuthService";

export class DynamicPricingTemplateService {
    url = `pricing_templates/`;

    list() {
        return AuthService.apiGet(this.url).then(res => res.data.data);
    }

    create(data) {
        return AuthService.apiPost(this.url, data).then(res => res.data.data);
    }

    update(id, data) {
        return AuthService.apiPut(this.url + id + "/", data).then(res => res.data.data);
    }

    remove(id, removeFromProducts) {
        return AuthService.apiDelete(this.url + id + "/", {
            params: {remove_from_products: removeFromProducts}
        }).then(res => res.data);
    }

    apply(id, productIds) {
        return AuthService.apiPut(this.url + id + "/apply/", {product_ids: productIds}).then(res => res.data);
    }

    reapply(id, pushHistory = true) {
        return AuthService.apiPut(this.url + id + "/reapply/", {}, {
            params: {push_history: pushHistory}
        }).then(res => res.data);
    }

    // Flip a rule's active flag AND propagate to its linked products so a
    // deactivation actually stops repricing on them. push_history=false keeps a
    // simple on/off toggle from bloating each product's strategy history.
    setActive(id, isActive, rule) {
        return this.update(id, {...rule, is_active: isActive})
            .then(() => this.reapply(id, false));
    }

    linked(id) {
        return AuthService.apiGet(this.url + id + "/linked/").then(res => res.data.data);
    }

    // Fully remove the applied template from the given products (clears the
    // pricing strategy and the template tag). Async; returns a queued ack.
    detach(productIds) {
        return AuthService.apiPost(this.url + "detach/", {product_ids: productIds}).then(res => res.data);
    }
}
